import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBizID, getStyle } from '../../libs/todoSlice';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import fontColor from '../../lib/fontColor';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import axios from "axios";
import Swal from 'sweetalert2';
import CircularProgress from '@mui/material/CircularProgress';
import { DatePicker, Input } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Search } = Input;

function formatThaiDate(input) {
  const monthsThai = [
    '',
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ];

  const date = new Date(input); 
  const day = date.getDate();
  const month = date.getMonth() + 1; 
  const year = date.getFullYear() + 543; 

  return `วันที่ ${day} เดือน ${monthsThai[month]} พ.ศ. ${year}`;
}



function ReNewCA() {
  const business_id = useSelector(getBizID);
  const style = useSelector(getStyle);
  const [selected, setSelected] = useState([]);
  const [listRenewCa, setListRenewCa] = useState([]);
  const [failRenewCa, setFailRenewCa] = useState([]);
  const [loadingApi, setLoadingApi] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // searching state
  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState(null);

  const headCells = [
    { id: 'Id', numeric: false, disablePadding: true, label: 'ลำดับที่', show: true },
    { id: 'requestID', numeric: false, disablePadding: true, label: 'เลขคำขอ CA (requestID)', show: true },
    { id: 'fullName', numeric: true, disablePadding: true, label: 'ชื่อ - นามสกุล', show: true },
    { id: 'email', numeric: true, disablePadding: true, label: 'อีเมล', show: true },
    { id: 'bizName', numeric: true, disablePadding: true, label: 'บัญชีนิติบุคคล', show: true },
    { id: 'bizPrefix', numeric: true, disablePadding: true, label: 'Prefix', show: true },
    { id: 'expiryDate', numeric: true, disablePadding: true, label: 'วันหมดอายุ', show: true },
    { id: 'failFor', numeric: true, disablePadding: true, label: 'หมายเหตุ', show: failRenewCa.length > 0 || loadingApi },
  ];

  async function handleGetListReNewCa() {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v5/renew-ca/list?biz_id=${business_id}`,
      );
      setListRenewCa(res.data.data);
      setSelected([]);
      return res.data;
    } catch (err) {
      if (err.response) {
        console.error('เกิดข้อผิดพลาด:', err.response.data.message || err.response.data);
      } else {
        console.error('เกิดข้อผิดพลาด:', err.message);
      }
      return null;
    }
  };

  useEffect(() => {
    handleGetListReNewCa();
    setLoadingApi(false);
    setFailRenewCa([]);
  }, []);

  useEffect(() => {
    setPage(0);
    setSelected([]);
  }, [searchQuery, dateRange]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = listRenewCa.map((n) => n.requestID);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  function EnhancedTableHead() {
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            
          </TableCell>
          {headCells.filter(headCell => headCell.show).map((headCell) => (
            <TableCell
              key={headCell.id}
              align='left'
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sx={{ fontWeight: "bold", pl: "15px" }}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  function EnhancedTableToolbar(props) {
    const { numSelected } = props;
    return (
      <Toolbar sx={[{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 }, },]} >
        {numSelected > 0 ? (
          <Typography
            sx={{ flex: '1 1 70%', display: 'flex', alignItems: 'center', gap: 1 }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            <Box
              component="span"
              sx={{
                backgroundColor: 'error.main', color: 'white', px: 2, py: 0.5, borderRadius: 1,
                fontWeight: 'bold', display: 'inline-flex', alignItems: 'center'
              }}
            >
              {numSelected}
            </Box>
            <Typography sx={{ flex: '1 1 70%' }} variant="h6" id="tableTitle" component="div" >
              <span style={{ fontWeight: 'bold' }}> จำนวนรายการที่เลือก </span>
            </Typography>
          </Typography>
        ) : (
          <Typography sx={{ flex: '1 1 70%' }} variant="h6" id="tableTitle" component="div" >
            <span style={{ fontWeight: 'bold' }}>รายการต่ออายุ CA</span>
          </Typography>
        )}
        <Tooltip placement="top" arrow>
          <Button
            variant="contained"
            disabled={numSelected === 0}
            startIcon={<AutorenewIcon />}
            onClick={() => handleReNewCa(selected)}
            sx={{
              mr: 1, width: 177,
              ...(!!style.primary_color && {
                backgroundColor: style.secondary_color,
                color: fontColor(style.secondary_color),
                '&:hover': { backgroundColor: `${style.secondary_color}dd` }
              })
            }}
          >
            ต่ออายุ CA
          </Button>
        </Tooltip>
      </Toolbar>
    );
  }

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  async function handleReNewCa(selectedIds) {
    setLoadingApi(true)
    const payload = selectedIds.map(id => {
      const row = listRenewCa.find(r => r.requestID === id);
      return {
        account_id: row.accountID,
        biz_id: row.biz_id
      };
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v5/renew-ca`,
        { payload: payload }
      );
      Swal.fire({
        title: "ส่งอีเมลสำเร็จ!",
        text: "ระบบได้แจ้งเตือนไปยังผู้ใช้งานเรียบร้อยแล้ว กรุณาให้ผู้ใช้งานเข้าสู่ระบบเพื่อดำเนินการต่ออายุใบรับรอง CA",
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });

      setSelected([]);
      handleGetListReNewCa();
      return res.data;
    } catch (err) {
      if (err.response.data.data.length > 0) {
        setLoadingApi(false);
        setFailRenewCa(err.response.data.data);
      }
      return null;
    }
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredList = listRenewCa.filter(row => {
    const matchesSearch = !searchQuery ||
      (row.requestID && row.requestID.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.fullname_th && row.fullname_th.toLowerCase().includes(searchQuery.toLowerCase()));

    const matchesDate = !dateRange || dateRange.length < 2 ||
      (dayjs(row.exp_date).isValid() &&
        dayjs(row.exp_date).isBetween(dateRange[0], dateRange[1], 'day', '[]'));
    return matchesSearch && matchesDate;
  });

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredList.length) : 0;
  
  const visibleRows = React.useMemo(
    () =>
      [...filteredList]
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [filteredList, page, rowsPerPage],
  );

  return (
    <Box >
      <Paper sx={{ mb: 2 }}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '20px',
          margin: 20,
          marginTop: 5,
          alignItems: 'center'
        }}>
          <Search
            placeholder="ค้นหาด้วย หมายเลขคำขอ หรือ ชื่อ-นามสกุล"
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ width: 400 }}
          />
          <RangePicker
            onChange={(dates) => setDateRange(dates)}
          />
        </div>

        <TableContainer>
          <Table
            sx={{ minWidth: 850 }}
            aria-labelledby="tableTitle"
            size='medium'
          >
            <EnhancedTableHead
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={filteredList.length}
              style={style}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = selected.includes(row.requestID);
                const labelId = `enhanced-table-checkbox-${index}`;
                const failDetail = failRenewCa.find(fail => fail.accountID === row.accountID && fail.bizID === row.biz_id);

                return (
                  <TableRow hover onClick={(event) => handleClick(event, row.requestID)} role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={row.requestID} selected={isItemSelected} sx={{ cursor: 'pointer' }} >
                    <TableCell padding="checkbox">
                      <Checkbox color="primary" checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId, }} />
                    </TableCell>
                    <TableCell align="left">{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell align="left">{row.requestID}</TableCell>
                    <TableCell align="left">{row.fullname_th}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.biz_name}</TableCell>
                    <TableCell align="left">{row.perfix}</TableCell>
                    <TableCell align="left">{formatThaiDate(row.exp_date)}</TableCell>
                    {failRenewCa.length > 0 ?
                      <TableCell align="left">{failDetail ? failDetail.msg : ""}</TableCell> :
                      loadingApi ?
                        <TableCell align="center"><CircularProgress size={20} /></TableCell> :
                        null
                    }
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows, }} >
                  <TableCell colSpan={headCells.filter(hc => hc.show).length + 1} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={filteredList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelRowsPerPage="จำนวนแถวต่อหน้า"
          sx={{
            '& .MuiInputBase-root': { color: 'primary.main', fontWeight: 'bold' },
            '& .MuiTablePagination-selectLabel ': { marginTop: 'auto', fontWeight: 'bold' },
            '& .MuiTablePagination-displayedRows ': { marginTop: 'auto', fontWeight: 'bold' },
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}

export default ReNewCA;